import React from 'react';
export const Demonstration = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-32" data-mp="3sdcrls0aky75">
      <h2 className="font-bold text-2xl md:text-3xl mt-12 mb-6 text-gray-900" data-id="element-33" data-mp="2pciwfcqn7w5">
        See The Difference
      </h2>

      <p data-id="element-34" data-mp="3k4rohmiparct">
        When comparing a traditional pillow to{' '}
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-35" data-mp="3p4e05rivrzji">
          VelaSleep
        </a>
        , the difference in alignment becomes immediately clear.
      </p>

      <div className="grid md:grid-cols-2 gap-6 my-8 text-base" data-id="element-36" data-mp="3g5agalbw3g3y">
        <div className="bg-gray-50 p-6 rounded-sm border border-gray-200" data-id="element-37" data-mp="317rjcvp25wlf">
          <h4 className="font-bold text-gray-900 mb-3 mt-0 text-lg" data-id="element-38" data-mp="319kuooam94zr">
            Traditional Pillow
          </h4>
          <ul className="m-0 pl-5 text-gray-700 space-y-2 list-disc" data-id="element-39" data-mp="368nwlzvauv3i">
            <li data-id="element-40" data-mp="zgwk1tvn7f9y">Neck support disappears</li>
            <li data-id="element-41" data-mp="14f7v27xobvtr">Head sinks unevenly</li>
            <li data-id="element-42" data-mp="14e6jm2cqx7bi">Increased pressure points</li>
            <li data-id="element-43" data-mp="14d3qdnryassf">Frequent repositioning</li>
          </ul>
        </div>
        <div className="p-6 rounded-sm border border-blue-200 bg-[#cee0e5]" data-id="element-44" data-mp="2qv54zz2u3hqw">
          <h4 className="font-bold text-blue-900 mb-3 mt-0 text-lg" data-id="element-45" data-mp="2lwv6behwhz0j">
            <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-46" data-mp="30navf4dftr3z">
              VelaSleep
            </a>
          </h4>
          <ul className="m-0 pl-5 text-blue-900 space-y-2 list-disc" data-id="element-47" data-mp="2vp0z2qfz8kgs">
            <li data-id="element-48" data-mp="27xlroj9cfcyo">Supports head and neck separately</li>
            <li data-id="element-49" data-mp="27ydmhrv496nw">Encourages better alignment</li>
            <li data-id="element-50" data-mp="22zk8lybx3dn7">Reduced pressure concentration</li>
            <li data-id="element-51" data-mp="230vgoaceb7k4">More stable sleep posture</li>
          </ul>
        </div>
      </div>

      <figure className="my-8" data-id="element-52" data-mp="2h0d5uqtlsmu0">
        <img src="https://cdn.magicpatterns.com/uploads/sY8SEBbFGZssZuGTk6qcsj/Demonstration.jpg" alt="Sleeping Positions Demonstration" className="w-full rounded-sm shadow-sm" data-id="element-53" data-mp="2gwh2k8nc1b8b" />
      </figure>

      <h3 className="font-bold text-xl md:text-2xl mt-10 mb-4 text-gray-900" data-id="element-54" data-mp="3od57vktuhdnp">
        Designed for Every Sleeper
      </h3>
      <p data-id="element-55" data-mp="2l0odzoewkon0">
        <strong data-id="element-56" data-mp="2l0y8npaw7jz1">Side Sleepers:</strong> Proper shoulder clearance. Supported
        neck position. Reduced compression.
      </p>
      <p data-id="element-57" data-mp="2q2do91uawya1">
        <strong data-id="element-58" data-mp="2uzx3o52qjh3k">Back Sleepers:</strong> Gentle cervical support. Balanced head
        positioning. Comfortable contouring.
      </p>
      <p data-id="element-59" data-mp="2z07mwjfjg40d">
        <strong data-id="element-60" data-mp="2yzxw4tmo5stm">Premium Memory Foam:</strong> Watch how the foam slowly returns
        to shape while maintaining support. Built for nightly use.
      </p>
    </section>;
};